module.exports = __webpack_public_path__ + "front/img/header-bg.17182a74.png";